import styled, { css, keyframes } from 'styled-components'

export const fadeOut = keyframes`
0% {
    opacity: 1;
 }
 100% {
   display: none;
   opacity: 0;
 }
`

export const Container = styled.div`
    ${props =>
        props.animate &&
        css`
            animation: 1.5s linear ${fadeOut} forwards;
            animation-iteration-count: 1;
        `}
`
